import React, { useMemo } from 'react';
import { createStyles } from 'utils/createStyle';
import { useRootSelector } from 'common/features/featuresReducer';
import { selectWalletAffiliateBonuses } from 'common/features/store/duck/wallet/duck';

const styles = createStyles({
    doubleDipMessage: [
        'flex h-8 w-full bg-pale-blue justify-center text-dark-blue font-semibold items-center',
        { borderTopRightRadius: 10, borderTopLeftRadius: 10, fontSize: 14 },
    ],
});

export const ShopOnlineWalletCardMarker = React.memo(({ brandId }: { brandId: number }) => {
    const affiliateBrandOffersSelector = useRootSelector(selectWalletAffiliateBonuses);

    const affiliateOffers = useMemo(() => {
        if (brandId && affiliateBrandOffersSelector) {
            return affiliateBrandOffersSelector(`${brandId}`);
        }
    }, [brandId, affiliateBrandOffersSelector]);

    if (!affiliateOffers?.canDoubleDip) {
        return null;
    }

    return (
        <div className={styles.doubleDipMessage}>
            <span>{`Shop online and earn ${affiliateOffers.variable ? 'up to' : ''} ${
                affiliateOffers.bestRebate
            }% more`}</span>
        </div>
    );
});
